module.exports = __webpack_public_path__ + "img/Workshop Graphic - PHP Swift.23adad93.png";